// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1TMNV","footer":"Form_footer__1Y_w2"};